import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const COLORS = ['#519839', '#D29034', '#EBECF0'];

export default function StatusPieChart({ completed, total }) {
  const pending = Math.max(0, total - completed);
  
  const data = [
    { name: 'Completed', value: completed },
    { name: 'Pending', value: pending }
  ];

  if (total === 0) {
    return <div style={{ color: 'var(--trello-text-muted)', fontSize: 13 }}>No tasks available for pie chart.</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={240}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={60}
          outerRadius={80}
          paddingAngle={5}
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
        <Legend verticalAlign="bottom" height={36}/>
      </PieChart>
    </ResponsiveContainer>
  );
}
